import { usePermissions } from '@/hooks/usePermissions'
import { useTranslation } from 'react-i18next'

import type { ColorScheme } from '@hivewatch/dark'
import { AlertTriangleIcon, Box, Flex, Modal } from '@hivewatch/dark'

import { MODAL_Z_INDEX } from '@/styles/theme'

interface DarkDeleteFilterConfirmationModalIProps {
  isOpen: boolean
  onClose: () => void
  filterName: string
  isLoading: boolean
  onConfirm: () => Promise<void>
  colorScheme: ColorScheme
}

export const DarkDeleteFilterConfirmationModal = ({
  isOpen,
  onClose,
  filterName,
  isLoading,
  onConfirm,
  colorScheme,
}: DarkDeleteFilterConfirmationModalIProps) => {
  const { t } = useTranslation()
  const { shouldEnableRemoveModal } = usePermissions()
  const dangerColor =
    colorScheme === 'light' ? 'light.icon.danger' : 'interactive.danger'

  return (
    <Modal
      colorScheme={colorScheme}
      isOpen={isOpen}
      isSaveDestructive
      isSaveDisabled={!shouldEnableRemoveModal}
      isSaveLoading={isLoading}
      onClose={onClose}
      onSave={() => {
        void onConfirm()
      }}
      saveButtonLabel={t('incidents:filter_confirm_removal')}
      showCancelButton
      size='compact'
      title={t('incidents:filter_delete_title')}
      zIndex={MODAL_Z_INDEX}
    >
      <Box>
        {t('incidents:filter_delete_body')}{' '}
        <Box as='span' fontWeight='bold'>
          {filterName}
        </Box>
        ?
      </Box>
      <Flex alignItems='center' color={dangerColor} gap='6px' pt='16px'>
        <AlertTriangleIcon color='currentColor' size={20} />
        <Box>
          <Box as='span' fontWeight='bold'>
            {t('common:warning')}
          </Box>{' '}
          {t('common:warning_cannot_be_undone')}
        </Box>
      </Flex>
    </Modal>
  )
}
